import { Injectable, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from 'src/app/models/User.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  private user: BehaviorSubject<User> = new BehaviorSubject({} as User);
  private token: BehaviorSubject<{ token: string }> = new BehaviorSubject(
    {} as { token: string }
  );
  get state(): Observable<User> {
    return this.user.asObservable();
  }
  get tokenValue(): { token: string } {
    return this.token.value;
  }
  get value(): User{
    return this.user.value;
  }
  setState(value: User) {
    this.user.next(value);
  }
  setToken(token: string) {
    this.token.next({ token });
  }
}
